<script lang="ts">
	//Components
	import TemplateThermostatControllerV2 from './Templates/TemplateThermostatControllerV2.svelte';
	import TemplatePVSystemControllerV2 from './Templates/TemplatePVSystemControllerV2.svelte';
	import TemplateCoverControllerV2 from './Templates/TemplateCoverControllerV2.svelte';
	import TemplateEVChargerControllerV2 from './Templates/TemplateEVChargerControllerV2.svelte';
	import ValidateTemplate from 'src/components/DevicesSettings/VirtualComponents/Templates/wizard/ValidateTemplate.svelte';
	import VGroupComponentsV2 from 'src/components/DevicesSettings/VirtualComponents/ComponentsV2/VGroupComponentsV2.svelte';
	//Helpers
	import { getVirtualTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import type { VirtualDeviceTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_types';

	export let device: Device;
	export let statuses: VCInterfaceStatus[];
	export let virtualTemplate: VirtualDeviceTemplate;

	let template: VirtualDeviceTemplate;
	$: template = virtualTemplate || getVirtualTemplate(device);
</script>

{#if template?.type}
	<ValidateTemplate {template} {statuses} />
{/if}
{#if template?.type === 'cover' || template?.type === 'valve'}
	<TemplateCoverControllerV2 {device} {statuses} />
{:else if template?.type === 'thermostat'}
	<TemplateThermostatControllerV2 {device} {statuses} />
{:else if template?.type === 'pv_system'}
	<TemplatePVSystemControllerV2 {statuses} />
{:else if template?.type === 'ev_charger'}
	<TemplateEVChargerControllerV2 {device} {statuses} />
{:else}
	<VGroupComponentsV2 {device} />
{/if}
